var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useId } from 'react';
import { useTheme } from '../../themes';
import AccessoryWrapper from '../AccessoryWrapper';
import { Typography } from '../Typography';
import { BuilderInputProps } from './modifiers';
import * as S from './styles';
export var Input = forwardRef(function (props, ref) {
    var _a;
    var theme = useTheme();
    var idProp = props.id, disabled = props.disabled, label = props.label, helperText = props.helperText, iconLeft = props.iconLeft, iconRight = props.iconRight, iconLeftAction = props.iconLeftAction, iconRightAction = props.iconRightAction, hasError = props.hasError, rest = __rest(props, ["id", "disabled", "label", "helperText", "iconLeft", "iconRight", "iconLeftAction", "iconRightAction", "hasError"]);
    var commonStyles = BuilderInputProps(props);
    var beforeIcon = theme.spacing.xxxs;
    var afterIcon = theme.spacing.xxxs;
    var labelPadding = function () { return ({
        marginLeft: iconLeft ? 0 : beforeIcon,
        marginRight: iconRight ? 0 : afterIcon,
    }); };
    var labelColor = !disabled
        ? theme.neutrals.pureBlack
        : theme.neutrals.gray4;
    var widthProps = {
        width: commonStyles.wrapper.width,
        minWidth: props === null || props === void 0 ? void 0 : props.minWidth,
        maxWidth: props === null || props === void 0 ? void 0 : props.maxWidth,
    };
    var heightProps = {
        height: commonStyles.wrapper.height,
        minHeight: props === null || props === void 0 ? void 0 : props.minHeight,
        maxHeight: props === null || props === void 0 ? void 0 : props.maxHeight,
    };
    var uuid = useId();
    var id = idProp || "field-".concat(uuid);
    var htmlFor = (_a = props === null || props === void 0 ? void 0 : props.labelTypographyProps) === null || _a === void 0 ? void 0 : _a.htmlFor;
    return (_jsxs(S.Container, __assign({ "data-testid": "inputContainer" }, widthProps, { hasError: hasError, disabled: disabled }, rest, { children: [label && (_jsx(Typography, __assign({ color: labelColor, mBottom: "nano", textAlign: "left", "data-testid": "label", htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : id }, commonStyles.text.labelTypographyProps, { children: label }))), _jsxs(S.Wrapper, __assign({ "data-testid": "inputWrapper" }, commonStyles.wrapper, heightProps, widthProps, { hasError: hasError, disabled: disabled }, { children: [iconLeft && (_jsx(AccessoryWrapper, __assign({ "data-testid": "iconLeft", mLeft: "nano", mRight: "nano", disabled: disabled, onClick: iconLeftAction }, { children: iconLeft }))), _jsx(S.Input, __assign({ ref: ref, "data-testid": "input", style: __assign({}, labelPadding()), disabled: disabled, id: id }, rest)), iconRight && (_jsx(AccessoryWrapper, __assign({ "data-testid": "iconRight", mLeft: "nano", mRight: "nano", disabled: disabled, onClick: iconRightAction }, { children: iconRight })))] })), helperText && (_jsx(Typography, __assign({ mTop: "nano", textAlign: "left", "data-testid": "helperText" }, commonStyles.text.helperTypographyProps, { children: helperText })))] })));
});
